import { define, Model, AttributesMixin } from "@type-r/models";
import { restfulIO } from "./endpoint";
import { RemittanceAdvice } from "./remittanceAdvice";

export interface ManualRemittanceAdvice extends AttributesMixin<typeof ManualRemittanceAdvice> { }

@define
export class ManualRemittanceAdvice extends Model {
    static endpoint = restfulIO('api/v1/ingest/remittance-advices');

    static attributes = {
        id: String,
        status: String,
        ...RemittanceAdvice.attributes
    }
}